<template>
  <div class="gateway-success">
    <div class="gateway-success__card">
      <div class="gateway-success__mark" aria-hidden="true">
        <v-icon large color="#0d4a36">mdi-check-circle-outline</v-icon>
      </div>
      <h1>Registrasi berhasil</h1>
      <p>
        Akun SenderWA Anda sudah dibuat. Silakan masuk ke dashboard untuk
        menghubungkan nomor WhatsApp dan mulai mengirim pesan.
      </p>
      <div class="gateway-success__actions">
        <router-link to="/login" class="gateway-success__btn">
          Masuk Dashboard
        </router-link>
        <router-link to="/home" class="gateway-success__link">
          Kembali ke beranda
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "RegistrasiBerhasilComponent",
  mounted() {
    this.setPage({ crud: false });
    window.scrollTo(0, 0);
    document.title = "Registrasi Berhasil — SenderWA";
  },
  methods: {
    ...mapActions(["setPage"]),
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@600;700&family=Source+Sans+3:wght@400;600&display=swap");

.gateway-success {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 2rem 1.25rem;
  font-family: "Source Sans 3", "Montserrat", sans-serif;
  background:
    radial-gradient(80% 60% at 50% 0%, rgba(143, 214, 181, 0.35), transparent 55%),
    #f8fbf9;
  color: #10241c;
}

.gateway-success__card {
  width: 100%;
  max-width: 440px;
  text-align: center;
  padding: 2.5rem 1.75rem;
  border: 1px solid #c9ddd3;
  border-radius: 16px;
  background: #fff;
}

.gateway-success__mark {
  width: 64px;
  height: 64px;
  margin: 0 auto 1.25rem;
  display: grid;
  place-items: center;
  border-radius: 16px;
  background: linear-gradient(145deg, #d8f3e5, #b7ebcf);
}

.gateway-success h1 {
  margin: 0;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-size: 1.7rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0d4a36;
}

.gateway-success p {
  margin: 0.85rem 0 1.75rem;
  color: #5d7268;
  line-height: 1.55;
  font-size: 0.98rem;
}

.gateway-success__actions {
  display: grid;
  gap: 0.85rem;
}

.gateway-success__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  border-radius: 10px;
  background: linear-gradient(135deg, #1f7a57, #0d4a36);
  color: #fff;
  text-decoration: none;
  font-family: "Outfit", sans-serif;
  font-weight: 600;
}

.gateway-success__link {
  color: #1f7a57;
  font-weight: 700;
  text-decoration: none;
  font-size: 0.92rem;
}

.gateway-success__link:hover {
  text-decoration: underline;
}
</style>
